import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "country-item-list" }

import { computed } from 'vue';
import Collapse from '@lmt-rpb/Collapse/Collapse.vue';
import CountryItemListContent from '@lmt-rpb/CountryItemListContent/CountryItemListContent.vue';
import CountryItemListHeader from '@lmt-rpb/CountryItemListHeader/CountryItemListHeader.vue';
import { getLocaleString } from '@utils/environmentUtils';
import { formatPrice, getTotalPrice } from '@/js/utils/priceUtils';
import type { BestOfferForRegion } from '@/interfaces/api/v1-best-offer-for-region';

import { type RegionItem } from '@/interfaces/region-item';

interface Props {
	items: BestOfferForRegion[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CountryRegionItemList',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props;
const currency = computed<string>(() => getLocaleString('currency'));

const regions = computed<RegionItem[]>(() => props.items.map((region) => ({ ...region, code: region.RegionGroupName })));

const bestPrices = computed<Record<string, number>>(() => props.items.reduce((acc, { RegionGroupName, Regions }, index) => {
		const key = RegionGroupName || index;
		const bestPrice = Regions.map(({ Pricing }) => getTotalPrice(Pricing)).sort((a, b) => a - b).shift();
		return { ...acc, [key]: bestPrice };
	}, {}));

const hotelSummary = computed<Record<string, number>>(() => props.items.reduce((acc, { RegionGroupName, Regions }, index) => {
		const key = RegionGroupName || index;
		const count = Regions.reduce((sum, { HotelCount }) => sum + HotelCount, 0);
		return { ...acc, [key]: count };
	}, {}));

const getRegionsCount = (regionItems: RegionItem[]): string => {
	if (regionItems && regionItems.length > 0) {
		return `(${regionItems.length})`;
	}
	return '';
};

const collapseHintText = (regionItems: RegionItem[]): string => {
	const regionNames = [];
	for (let i = 0; i < 5; i++) {
		if (!regionItems[i]) {
			break;
		}
		regionNames.push(regionItems[i].Name);
	}
	return regionNames.join(', ');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(regions.value, (region, index) => {
      return (_openBlock(), _createBlock(Collapse, {
        key: region.RegionGroupID,
        open: index === 0,
        class: "country-item-list__collapse",
        "data-region": region.RegionGroupName,
        "keep-alive": false
      }, {
        header: _withCtx(({ isOpen }) => [
          _createVNode(CountryItemListHeader, {
            region: region,
            "is-open": isOpen,
            "best-prices": bestPrices.value,
            "get-regions-count": getRegionsCount,
            "collapse-hint-text": collapseHintText,
            "format-price": _unref(formatPrice)
          }, null, 8 /* PROPS */, ["region", "is-open", "best-prices", "format-price"])
        ]),
        default: _withCtx(() => [
          _createVNode(CountryItemListContent, {
            region: region,
            currency: currency.value,
            "hotel-summary": hotelSummary.value,
            "best-prices": bestPrices.value
          }, null, 8 /* PROPS */, ["region", "currency", "hotel-summary", "best-prices"])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["open", "data-region"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})